export default __webpack_public_path__ + "static/sp-menu-80ae7cfd9829f8201b3f34fd5a547d11.png";